// extracted by mini-css-extract-plugin
module.exports = {"container":"UniswapExchange_container__IQfdx"};